import React from "react";
import OtpTableComponent from "./otpTable.component";
import { useOtpReport } from "modules/otp-report/context/otpReport.context";

function OtpTableContainer({
  handleChangePage,
  handleChangeRowsPerPage,
  changeOrder
}) {
  const {
    isFetching,
    data,
    page,
    rowsPerPage,
    totalRecords,
    tableFilter,
    search,
    paginationOptions,
    lang,
    language
  } = useOtpReport();

  return (
    <OtpTableComponent
      rows={data}
      page={page}
      rowsPerPage={rowsPerPage}
      handleChangePage={handleChangePage}
      handleChangeRowsPerPage={handleChangeRowsPerPage}
      isFetching={isFetching}
      totalRecords={totalRecords}
      language={language}
      search={search}
      paginationOptions={paginationOptions}
      lang={lang}
      tableFilter={tableFilter}
      changeOrder={changeOrder}
    />
  );
}

export default OtpTableContainer;
